export default "__VITE_ASSET__CITgc3An__"